<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-8 mt-2 mt-8 sm:-mt-px mb-8">
        <site-development-required
            v-model="site_development_is_required"
            :read_only="read_only"
        />

        <div v-if="site_development_is_required">
            <site-development-date
                :commercial="commercial"
                :read_only="read_only"
            />

            <site-development-applied-for
                :commercial="commercial"
                :read_only="read_only"
            />

            <site-development-who-pays
                :commercial="commercial"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import SiteDevelopmentRequired from './site-development-required.vue';
import SiteDevelopmentDate from './site-development-date.vue';
import SiteDevelopmentAppliedFor from './site-development-applied-for.vue';
import SiteDevelopmentWhoPays from './site-development-who-pays.vue';

export default {
    components: {
        SiteDevelopmentRequired,
        SiteDevelopmentDate,
        SiteDevelopmentAppliedFor,
        SiteDevelopmentWhoPays,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            site_development_is_required: this.commercial.site_development_is_required,
        }
    },
}
</script>
